import React, { useEffect, useRef, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaTimes } from 'react-icons/fa';
import SideNavMenu from './SideNavMenu';

const SideNav = ({ isOpen, toggleSideNav }) => {
  const [isMobile, setIsMobile] = React.useState(false);
  
  // التأكد من أن toggleSideNav هو function صحيح
  const safeToggleSideNav = useCallback(() => {
    try {
      if (typeof toggleSideNav === 'function') {
        toggleSideNav();
      }
    } catch (error) {
    }
  }, [toggleSideNav]);
  const { i18n } = useTranslation("global");
  const sideNavRef = useRef();

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1200);
    };
    
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      try {
        if (
          isOpen &&
          window.innerWidth < 1200 &&
          sideNavRef.current &&
          !sideNavRef.current.contains(event.target)
        ) {
          safeToggleSideNav();
        }
      } catch (error) {
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside); // for touch devices (iPhone, Android)

    return () => {
      try {
        document.removeEventListener("mousedown", handleClickOutside);
        document.removeEventListener("touchstart", handleClickOutside);
      } catch (error) {
      }
    };
  }, [isOpen, safeToggleSideNav]);

  const handleLinkClick = () => {
    if (window.innerWidth < 1200) {
      safeToggleSideNav();
    }
  };

  return (
    <div
      ref={sideNavRef}
      className={`sidenav ${isOpen ? "openNav" : "closedNav"}`}
      style={{ zIndex: 1 }}
    >
      <span className="closeNav" onClick={safeToggleSideNav}>
        <FaTimes />
      </span>
      <div className="mx-auto my-2" style={{textAlign : "center"}}>
        <Link to="/">
          <div 
            style={{ 
              textDecoration: "none",
              padding: "10px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <img 
              src="/logokhadamat.png" 
              alt="khadamat Logo" 
              style={{
                height: "50px",
                width: "auto",
                maxWidth: "100%"
              }}
            />
          </div>
        </Link>
      </div>
      <SideNavMenu handleLinkClick={handleLinkClick} />
    </div>
  );
};

export default SideNav;
